let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("52dqm")).then(() => parcelRequire('3zSMJ'));